import { tokens as cssTokens } from '@paypalcorp/pp-react'

const {
  size: {
    icon: { xs: sysSizeIconXs },
    pictogram: { sm: sysSizePictogramSm },
  },
  space: { xs: sysSpaceXs, lg: sysSpaceLg },
  color: {
    background: {
      alt: sysColorBackgroundAlt,
      surface: sysColorBackgroundSurface,
      highContrast: sysColorBackgroundHighContrast,
      mediumContrast: sysColorBackgroundMediumContrast,
    },
    primary: {
      main: sysColorPrimaryMain,
      mainHover: sysColorPrimaryMainHover,
      contrast: sysColorPrimaryContrast,
    },
    secondary: {
      main: sysColorSecondaryMain,
      contrast: sysColorSecondaryContrast,
    },
    featured: { main: sysColorFeaturedMain },
    selected: {
      main: sysColorSelectedMain,
      contrast: sysColorSelectedContrast,
    },
    unselected: {
      main: sysColorUnselectedMain,
      mainActive: sysColorUnselectedMainActive,
      contrast: sysColorUnselectedContrast,
    },
    selectedRange: {
      main: sysColorSelectedRangeMain,
      contrast: sysColorSelectedRangeContrast,
    },
    accent1: { main: sysColorAccent1Main },
    accent4: { main: sysColorAccent4Main },
    error: { main: sysColorErrorMain },
    warning: { alt: sysColorWarningAlt },
    structure: {
      borderHighContrast: sysColorStructureBorderHighContrast,
      borderLowContrast: sysColorStructureBorderLowContrast,
      focus: sysColorStructureFocus,
      shadow: sysColorStructureShadow,
    },
  },
} = cssTokens

export default {
  sysSizeIconXs,
  sysSizePictogramSm,
  sysSpaceXs,
  sysSpaceLg,
  sysColorBackgroundAlt,
  sysColorBackgroundSurface,
  sysColorBackgroundHighContrast,
  sysColorBackgroundMediumContrast,
  sysColorPrimaryMain,
  sysColorPrimaryMainHover,
  sysColorPrimaryContrast,
  sysColorSecondaryMain,
  sysColorSecondaryContrast,
  sysColorFeaturedMain,
  sysColorSelectedMain,
  sysColorSelectedContrast,
  sysColorUnselectedMain,
  sysColorUnselectedMainActive,
  sysColorUnselectedContrast,
  sysColorSelectedRangeMain,
  sysColorSelectedRangeContrast,
  sysColorAccent1Main,
  sysColorAccent4Main,
  sysColorErrorMain,
  sysColorWarningAlt,
  sysColorStructureBorderHighContrast,
  sysColorStructureBorderLowContrast,
  sysColorStructureFocus,
  sysColorStructureShadow,
}
